import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-python-course',
    templateUrl: './python-course.component.html',
    styleUrls: ['./python-course.component.css'],
    standalone: false
})
export class PythonCourseComponent {
// Data for all weeks
  weeks = [
    {
      title: "DAY 1: Introduction to Python ",
      content: `
     <p><strong>Focus:</strong></p>
     <ul>
     <li>What is Python? </li>
    <li>Why learn Python? </li>
     <li>Python in real-world applications</li>
     <li>Writing and running first program- print statement </li>
    </ul>
     `,
    },
    {
      title: "Day 2: Variables and Data Types ",
      content: `
     <p><strong>Focus:</strong></p>

     <ul>
    <li>Variables and naming rules </li>
     <li>Data types: int, float, str, bool </li>
     <li>Type casting (int(), str(), float()) </li>
     <li>Simple arithmetic </li>
    </ul>
     `,
    },
    {
      title: "Day 3: Input and Output ",
      content: `
     <p><strong>Focus:</strong></p>

     <ul>
     <li>Sensory Language and its use</li>
    <li>input() function and print() formatting </li>
     <li>Reading user input </li>
     <li>Type conversion with input </li>
     <li>Practice: Python programs related to topics </li>
    </ul>

     `,
    },
    {
      title: "Day 4: Operators",
      content:  `
      <p><strong>Focus:</strong> Descriptive Writing - Image and scenario based questions</p>
 
      <ul>
      <li>Arithmetic, comparison, logical, assignment operators </li>
 
      <li>Operator precedence</li>

      <li>Practice: Python programs related to topics </li>
 
     </ul>
      `,
    },
    {
      title: "Day 5: Control Flow and Decision Making: If Statements",
      content: `
      <p><strong>Focus:</strong> Story Creation and Story Completion Questions</p>
 
      <ul>
      <li>if, elif, else </li>
 
      <li>Nesting conditions </li>
      <li>Practice: Simple if else programs, odd/even, voting eligibility </li>
 
 
     </ul>
      `,
    },
    {
      title: "Day 6: Logical Conditions ",
      content: `
      <p><strong>Focus:</strong> Instructional Writing, Newspaper Article and Journal Entry, Persuasive writing</p>
 
      <ul>
      <li>and, or, not with conditions </li>
 
      <li>Practice: Login simulator with username and password</li>
 
     </ul>
      `,
    },
    {
      title: "Day 7: Doubt session",
      content: `
      <p><strong> Programming Practice session(10 -12 programs)</strong></p>

      `,
    },
    {
      title: "Day 8: Loops and Data Structures:While Loop ",
      content: `
      <p><strong>Focus:</strong></p>
 
      <ul>
      <li>Structure of while loop</li>
 
      <li>Infinite loops and break, continue</li>

      <li>Practice: Number guessing game </li>

 
     </ul>
      `,
    },
    {
      title: "Day 9: Loops and Data Structures:While Loop ",
      content: `
      <p><strong>Focus:</strong></p>
 
      <ul>
      <li>Structure of while loop</li>
 
      <li>Infinite loops and break, continue</li>

      <li>Practice: Number guessing game </li>

 
     </ul>
      `,
    },

    {
      title: "Day 10: Loops and Data Structures:While Loop ",
      content: `
      <p><strong>Focus:</strong></p>
 
      <ul>
      <li>Creating and accessing lists</li>
 
      <li>Infinite loops and break, continue</li>

      <li>Practice: Number guessing game </li>

 
     </ul>
      `,
    },
    {
      title: "Day 11: Functions and Error Handling:Functions",
      content: `
      <p><strong>Focus:</strong></p>
 
      <ul>
      <li>Defining functions</li>
 
      <li>Parameters and return values</li>

      <li>Practice: Function to convert temperature, area of shapes,perimeter of shapes</li>
     </ul>
      `,
    },

    {
      title: "Day 12: Scope and Modularity ",
      content: `
      <p><strong>Focus:</strong></p>
 
      <ul>
      <li>Local vs global variables</li>
 
      <li>Reusability of functions</li>

      <li>Importing built-in modules (e.g. random, math)</li>

 
     </ul>
      `,
    },

    {
      title: "Day 13: Error Handling ",
      content: `
      <p><strong>Focus:</strong></p>
 
      <ul>
      <li>Syntax vs runtime vs logical errors </li>
 
      <li>Try/except blocks </li>

      <li>Practice: Division, file opening, number inputs </li>

 
     </ul>
      `,
    },

    {
      title: "Day 14: Strings, File Handling, and Recap: String Manipulation",
      content: `
      <p><strong>Focus:</strong></p>
 
      <ul>
      <li>String methods: upper(), lower(), replace(), split(), join() </li>
 
      <li>Indexing, slicing, concatenation </li>

      <li>Practice: Programs related to above topics </li>

 
     </ul>
      `,
    },

    {
      title: "Day 15: File Input and Output (Optional/Extension) ",
      content: `
      <p><strong>Focus:</strong></p>
 
      <ul>
      <li>Opening, reading, writing to files (open(), read(), write()) </li>
 
      <li>with keyword and file handling best practices </li>

      <li>Practice: Reading a text file and printing lines </li>

 
     </ul>
      `,
    },

    {
      title: "Day 16: Introduction to sorting (Bubble Sort conceptually)",
      content: `
     

 
     </ul>
      `,
    },

    {
      title: "Day 17: Algorithms, Revision, and Assessment:Search and Sort Algorithms ",
      content: `
      <p><strong>Focus:</strong></p>
 
      <ul>
      <li>Linear search implementation </li>
 
      <li>Introduction to sorting (Bubble Sort conceptually) </li>

      <li>Practice: Number guessing game </li>

 
     </ul>
      `,
    },

    {
      title: "Day 18: Revision 1 – Fundamentals",
      content: `
      <p><strong>Focus:</strong></p>
 
      <ul>
      <li>Review: Variables, Data Types, Operators, Input/Output </li>
 
      <li>Programming practice+ in class test </li>

 
     </ul>
      `,
    },

    {
      title: "Day 19: Revision 2 – Control Flow and Functions ",
      content: `
      <p><strong>Focus:</strong></p>
 
      <ul>
      <li>Review: Loops, Conditions, Functions, Lists </li>
 
      <li>Programming practice+ in class test </li>

      <li>Practice: Number guessing game </li>

 
     </ul>
      `,
    },

    {
      title: "Day 20: Mock Assessment ",
      content: `
      <p><strong>Full-length paper-style mock exam </strong></p>

      `,
    },
  ];

  openIndex = 0; // open the first by default

  toggleAccordion(index: number) {
    this.openIndex = this.openIndex === index ? -1 : index;
  }

  bookSlot():void {
    window.location.href = "https://www.sehyog.co.uk/11plus-help-club/category/workshop/37747c70c1dd21ea137404f6a98a1bd2";
  }
}
